import React, { useEffect, useState } from "react";
import "../adminMember.css";
import axios from "../../../../../../axios";

const GroupMember = ({
  group,
  communityId,
  inEditingMode,
  setDeletingAllMembersDetails,
  deletingAllMembersDetails,
}) => {
  const [groupMember, setGroupMember] = useState([]);
  const { deletingStudents } = deletingAllMembersDetails;
  useEffect(() => {
    try {
      const getGroupMember = async () => {
        let res = await axios.get(
          `/community/${communityId}/groupId/${group?.id}/getMember`
        );
        res && setGroupMember(res.data.data.members);
      };
      getGroupMember();
    } catch (error) {
      console.log(error);
    }
  }, []);

  const handleDeleteMember = (member) => {
    if (deletingStudents.includes(member)) {
      const newStudentsList = deletingStudents.filter((a) => a !== member);
      setDeletingAllMembersDetails((prevState) => ({
        ...prevState,
        deletingStudents: newStudentsList,
      }));
    } else {
      setDeletingAllMembersDetails((prev) => ({
        ...prev,
        deletingStudents: [...prev.deletingStudents, member],
      }));
    }
  };

  return (
    <>
      {groupMember &&
        groupMember.length > 0 &&
        groupMember.map((member, index) => (
          <div
            key={index}
            className="col-12 d-flex align-items-center justify-content-center"
          >
            <div className=" col-10 d-flex align-items-center justify-content-between member_boxes">
              <span className=" px-2 groups_person">
                {member?.student?.name}
              </span>
              {inEditingMode && (
                <>
                  {!deletingStudents.includes(member.id) ? (
                    <img
                      onClick={(e) => handleDeleteMember(member.id)}
                      src="/images/Dustbin.svg"
                      alt=""
                    />
                  ) : (
                    <img
                      onClick={(e) => handleDeleteMember(member.id)}
                      src="/images/redDustbin.svg"
                      alt=""
                    />
                  )}
                </>
              )}
            </div>
          </div>
        ))}
    </>
  );
};

export default GroupMember;
